import emailValidation from "../validations/emailValidations";

const loginFormValidation = (email: string) => {
  let status = false;
  let statusMessage = "";
  let { isValidEmail, validEmailStatus } = emailValidation(email);
  if (isValidEmail) {
    status = true;
  }
  if (isValidEmail === false) {
    status = false;
    statusMessage = validEmailStatus;
  }
  return { status, statusMessage };
};

export default loginFormValidation;
